import { render, staticRenderFns } from "./Fundings.vue?vue&type=template&id=4b7ae7dd&scoped=true&"
import script from "./Fundings.vue?vue&type=script&lang=js&"
export * from "./Fundings.vue?vue&type=script&lang=js&"
import style0 from "./Fundings.vue?vue&type=style&index=0&id=4b7ae7dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ae7dd",
  null
  
)

export default component.exports